import getEnumOptions from 'APP_ROOT/utils/getEnumOptions';
// import { memoize } from 'lodash';
import { AUTOCOMPLETE } from '../../../../constants/fieldTypes.js';
import { REPEATING_VALUE } from '../../../../modules/FormBuilder/constants/fieldAutocomplete.js';

const getEnums = props => {
  const {
    dataEnums,
    dataKey = '',
    enumRef: propsEnumRef = '',
    field_type: type = '',
    parentIndex = 0,
    parentKey = '',
    combinedEnumRef = null,
    parentEnum,
    options = {},
  } = props;
  const { source = '', displayEnumRef = '' } = options;
  // displayEnumRef exist only when displayFrom is set
  const _enumRef = displayEnumRef || propsEnumRef;

  const hasParent = !!parentKey;
  const hasPopulateFromRepeater = source === REPEATING_VALUE;
  // fallback enumRef to dataKey only when the source is repeating
  // all the other cases is ok to keep the same value
  const enumRef = hasPopulateFromRepeater ? _enumRef || dataKey : _enumRef;
  const enumPath = hasParent ? `${enumRef}-${parentIndex}-${dataKey}` : null;
  const enumOptions = {
    dataEnums,
    enumRef,
    parentEnum,
  };
  const dataEnumOptions = getEnumOptions(null, [], enumOptions);
  if (!(hasParent && type === AUTOCOMPLETE)) {
    return dataEnumOptions;
  }
  const dynamicDataEnumOptions = getEnumOptions(
    hasPopulateFromRepeater ? null : enumPath,
    [],
    enumOptions
  );
  const combinedEnums = getEnumOptions(combinedEnumRef, [], enumOptions);
  return [...(combinedEnumRef ? combinedEnums : []), ...dynamicDataEnumOptions];
};

export default getEnums;
// export without memoize for dynamic enums, because
// we cannot invalidate memoize cache
export { getEnums as getEnumsDynamic };
